// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/tabs-standalone/tabs-standalone.component.scss
// module id = 539
// module chunks = 0